import React from "react";
import "./App.css";

import {Routes,Route,Link} from "react-router-dom"
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Test from "./components/Test";
function App() {



  return (
    <div className="App">
      <h1>Typing_Champions</h1>
    
      <div className="navbar">
       <Link to="/"><li>Userlogin</li></Link> 
        <Link to="/test"> <li>Test</li></Link>
        <Link to="/dashboard"> <li>Dashboard</li></Link>
      </div>
      <Routes>
        <Route path="/" element={<Login/>}/>
        <Route path="/test" element={<Test/>}/>
        <Route path="/dashboard" element={<Dashboard/>}/>
      </Routes>
     
    </div>
  );
}

export default App;
